import { render } from "./appView.vue?vue&type=template&id=4e219a9d&scoped=true"
import script from "./appView.vue?vue&type=script&lang=js"
export * from "./appView.vue?vue&type=script&lang=js"

import "./appView.vue?vue&type=style&index=0&id=4e219a9d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e219a9d"]])

export default __exports__